import React, { memo } from 'react'
import { Box, Container } from '@mui/material'

import PageTitle from '../shared/pageTitle/PageTitle'
import ExchangeTargetCard from './ExchangeTargetCard'
import ConnectExchangeProvider from './ConnectExchangeProvider'

const ExchangePoints = ({
  selectedProvider,
  onExchange,
  exchangeProviderProfile,
  dispatchActionExchange,
  tokenProfile,
  cryptoExchanges,
  t,
  isDisabledPointsBurn,
  setProvider,
  exchangeWhitelist,
  isConnected,
  onConnectProvider,
  onQrCodeClick,
  onClickSignup,
  onAlertClose,
  redeemState,
  loading
}) => {
  return (
    <Container maxWidth='lg'>
      <PageTitle
        title={t('navigation.exchange', { symbol: tokenProfile.symbol })}
      />
      <Box
        sx={{
          gap: 3,
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)'
          }
        }}
      >
        <ExchangeTargetCard
          exchangeProviderProfile={exchangeProviderProfile}
          dispatchAction={dispatchActionExchange}
          provider={selectedProvider}
          onSubmit={onExchange}
          tokenProfile={tokenProfile}
          cryptoExchanges={cryptoExchanges}
          t={t}
          disabled={isDisabledPointsBurn || !isConnected}
          setProvider={setProvider}
          exchangeWhitelist={exchangeWhitelist}
          onAlertClose={onAlertClose}
          redeemState={redeemState}
          loading={loading}
        />
        <ConnectExchangeProvider
          provider={selectedProvider}
          tokenProfile={tokenProfile}
          isConnected={isConnected}
          onFormSubmit={onConnectProvider}
          exchangeProviderProfile={exchangeProviderProfile}
          dispatchAction={dispatchActionExchange}
          onQrCodeClick={onQrCodeClick}
          onClickSignup={onClickSignup}
          t={t}
        />
      </Box>
    </Container>
  )
}

export default memo(ExchangePoints)
